import { requestUrl } from "@/config/config";
// 套餐 失效
export const expire = (code) => `${requestUrl}/manage/menu/expire?code=${code}`;
// 发放
export const grant = `${requestUrl}/paycenter/grant`;
// 国版币 失效
export const expirePay = (id) => `${requestUrl}/paycenter/expire?id=${id}`;
